module.exports = __webpack_public_path__ + "assets/images/cockpit/cockpit_cropped_dark_ru.png";